export default "__VITE_ASSET__LtBWqgnO__"